/* global fetch, window */

(() => {
  class ServiceRepairApiError extends Error {
    constructor(message, status = 0, code = '') {
      super(message);
      this.name = 'ServiceRepairApiError';
      this.status = status;
      this.code = code;
    }
  }

  class ServiceRepairApi {
    constructor(config = {}) {
      this.basePath = String(config.basePath || '/apps/service-repair').replace(/\/$/, '');
      this.paths = {
        pickupSlots: config.pickupSlotsPath || 'dhl/pickup-slots',
        popPoints: config.popPointsPath || 'dhl/pop-points',
        requests: config.requestsPath || 'requests',
        status: config.statusPath || 'status',
      };
    }

    getPickupSlots(address) {
      return this.request(this.paths.pickupSlots, {
        method: 'POST',
        body: { address },
      });
    }

    getPopPoints(address) {
      return this.request(this.paths.popPoints, {
        method: 'POST',
        body: { address },
      });
    }

    createRepairRequest(payload) {
      return this.request(this.paths.requests, {
        method: 'POST',
        body: payload,
      });
    }

    getRepairRequestReceipt(receipt) {
      return this.request(`${this.paths.requests}/${encodeURIComponent(receipt)}`);
    }

    getRepairStatus(payload) {
      return this.request(this.paths.status, {
        method: 'POST',
        body: payload,
      });
    }

    async request(path, { method = 'GET', body } = {}) {
      let response;

      try {
        const headers = { Accept: 'application/json' };
        if (body !== undefined) headers['Content-Type'] = 'application/json';

        response = await fetch(this.resolveUrl(path), {
          method,
          credentials: 'same-origin',
          headers,
          body: body === undefined ? undefined : JSON.stringify(body),
        });
      } catch {
        throw new ServiceRepairApiError('Nie udało się połączyć z usługą serwisową. Spróbuj ponownie.', 0, 'NETWORK');
      }

      const responseBody = await this.readResponseBody(response);

      if (!response.ok) {
        throw new ServiceRepairApiError(
          responseBody?.error || responseBody?.message || 'Usługa serwisowa zwróciła błąd. Spróbuj ponownie.',
          response.status,
          responseBody?.code || 'REQUEST_FAILED',
        );
      }

      return responseBody || {};
    }

    resolveUrl(path) {
      const normalizedPath = String(path || '').replace(/^\//, '');
      const basePath = this.basePath.startsWith('/') ? this.basePath : `/${this.basePath}`;

      return new window.URL(`${basePath}/${normalizedPath}`, window.location.origin).toString();
    }

    async readResponseBody(response) {
      const contentType = response.headers.get('content-type') || '';

      if (!contentType.includes('application/json')) return null;

      try {
        return await response.json();
      } catch {
        return null;
      }
    }
  }

  window.ServiceRepairApi = ServiceRepairApi;
  window.ServiceRepairApiError = ServiceRepairApiError;
})();
